import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { Formik, Form } from "formik"
import {useDispatch, useSelector} from "react-redux"

import LoginForm from "./LoginForm"
import PasswordExpiredDialog from "./PasswordExpiredDialog"
import {
    login,
    showRequestPasswordChange
} from "../../actions/Utils/app"
import { getPasswordExpiredSelector, getExpiredUsernameSelector } from "../../reducers/Utils/app"
import HelpButton from "../../components/HelpButton"
import helpLinks from "../../utils/HelpLinks"
import { loginSchema } from "../../utils/yupValidators"


const useStyles = makeStyles({
    card: {
        background: "#fff",
        border: "1px solid #DBDBDB",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgba(0,0,0,.04)",
        borderRadius: 8,
        width: 364,
        "& .MuiCardContent-root": {
            padding: "32px 32px 0",
        },
        "& .MuiCardActions-root": {
            padding: "24px 32px 32px",
            justifyContent: "center",
        },
        "& .MuiButton-containedPrimary": {
            backgroundColor: "#2196F3",
            boxShadow: "0 1px 2px rgba(0,0,0,.18)",
        },
        "& .MuiButton-containedPrimary:hover": {
            backgroundColor: "#2196F3",
            boxShadow: "0 1px 2px rgba(0,0,0,.18)",
            filter: "brightness(.93)",
        },
    },
    title: {
        fontWeight: 500,
        fontSize: 20,
        lineHeight: "28px",
        color: "#555555",
        marginBottom: 24,
    },
    forgotRow: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 12,
        marginBottom: 2,
    },
    forgotLink: {
        fontSize: 14,
        lineHeight: "22px",
        color: "#555555",
        textDecoration: "underline",
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        fontFamily: "inherit",
        "&:hover": { color: "#000" },
    },
    belowCard: {
        marginTop: 24,
        width: 364,
        textAlign: "center",
        fontSize: 14,
        lineHeight: "22px",
        color: "#555555",
    },
    belowLink: {
        color: "#555555",
        textDecoration: "underline",
        cursor: "pointer",
        background: "none",
        border: "none",
        padding: 0,
        fontFamily: "inherit",
        fontSize: 14,
        "&:hover": { color: "#000" },
    },
})

const Login = (props) => {
    const {
        location
    } = props

    const classes = useStyles()
    const dispatch = useDispatch()

    const passwordExpired = useSelector(getPasswordExpiredSelector)
    const expiredUsername = useSelector(getExpiredUsernameSelector)

    const _login = values => {
        dispatch(login(values.username, values.password, location.state && location.state.returnPath))
    }

    const changePassword = () => dispatch(showRequestPasswordChange())

    return (
        <div className="flexCenter height100">
            {passwordExpired && <PasswordExpiredDialog username={expiredUsername} />}
            <Formik
                enableReinitialize
                initialValues={{
                    username: "",
                    password: ""
                }}
                onSubmit={_login}
                validationSchema={loginSchema}
            >
                {({
                    values,
                    errors,
                    handleChange
                }) => {
                    return (
                        <Form>
                            <Card className={classes.card}>
                                <CardContent>
                                    <Typography className={classes.title}>
                                        Se connecter
                                    </Typography>
                                    <LoginForm
                                        values={values}
                                        errors={errors}
                                        handleChange={handleChange}
                                    />
                                    <div className={classes.forgotRow}>
                                        <button
                                            type="button"
                                            className={classes.forgotLink}
                                            onClick={changePassword}
                                        >
                                            Mot de passe oublié ?
                                        </button>
                                    </div>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        color="primary"
                                        type="submit"
                                        variant="contained"
                                    >
                                        ME CONNECTER
                                    </Button>
                                </CardActions>
                            </Card>
                        </Form>
                    )
                }}
            </Formik>
            <HelpButton link={helpLinks.login} />
        </div>
    )
}

export default Login
